// Detects whether the app is running inside a Cypress e2e run.
export const isCypress = () =>
	typeof window !== 'undefined' && !!(window as unknown as { Cypress?: unknown })?.Cypress;
